import { render, staticRenderFns } from "./MPopupPostCopy.vue?vue&type=template&id=afc897cc&"
import script from "./MPopupPostCopy.vue?vue&type=script&lang=ts&"
export * from "./MPopupPostCopy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports